const ONE_TIME_INVOICE_ITEM_TYPE = {
  LateFee: "lateFee",
  Upsell: "upsell",
  Equipment: "equipment",
  HolidayCompensation: "holidayCompensation",
  Miscellaneous: "miscellaneous",
};

export default ONE_TIME_INVOICE_ITEM_TYPE;
